export default {
  browse: {
    title: "Browse",
    sections: {
      advancedTools: "Advanced Tools",
      freeTools: "Free Tools",
    },
    gamesOfPeriod: "Games of the {{period}}",
    periods: {
      day: "day",
      week: "week",
    },
    gameCount_one: "{{count}} Game",
    gameCount_other: "{{count}} Games",
  },
};